module.exports = __webpack_public_path__ + "img/ck-ranking+3.410fb6e6.png";